import { ConversationMessageEntity } from '@marketplace-web/messaging/conversation-messaging-data'
import { OfferMessage } from '@marketplace-web/offers/price-offers-data'

export function isOfferMessage(message: ConversationMessageEntity): message is OfferMessage {
  if (!message) return false

  return 'isCurrentOffer' in message
}
